import { useState } from 'react';
import Select from 'react-select';
import axios from 'Axios';
import { FileText } from 'tabler-icons-react';
import { rgba } from 'polished';
import { selectStyles } from 'Styles';
import { clx, toastify, api } from 'Utils';
import { AddStoryBox, FieldMessage } from 'Elements';
import styles from 'partials/dashboard/user-form.module.scss';

export const AddStoryLink = ({ onAdd, onRemove, storyId, ...props }) => {
	const [state, setState] = useState({
		fields: {
			title: '',
			desciption: '',
			link: null,
			link_id: ''
		},
		social_list: [
			{ value: 'telegram', label: 'telegram' },
			{ value: 'instagram', label: 'instagram' },
			{ value: 'facebook', label: 'facebook' },
			{ value: 'twitter', label: 'twitter' },
			{ value: 'linkedin', label: 'linkedin' },
			{ value: 'whatsapp', label: 'whatsapp' },
			{ value: 'website', label: 'website' }
		],
		errors: {},
		isSubmiting: false
	});

	const customSelect = {
		...selectStyles,
		control: () => ({
			...selectStyles.control(),
			borderRadius: 10,
			borderColor: '#fff',
			// boxShadow:
			// 	state.isFocused &&
			// 	`0 1px 5px ${rgba(rgba('#203696', 0.2), 0.25)} inset`,
			boxShadow: `0 3px 6px ${rgba('#203696', 0.2)}`,
			transition: 'all 0.3s'
		}),
		menu: () => ({
			...selectStyles.menu(),
			borderRadius: 10,
			border: `1px solid ${rgba('#c9cdd9', 0.5)}`
		}),
		singleValue: () => ({
			...selectStyles.singleValue(),
			fontSize: '14px',
			color: ' #001727'
		}),
		option: () => ({
			...selectStyles.option(),
			':not(:last-child)': {
				borderBottom: `1px solid ${rgba('#c9cdd9', 0.5)}`
			}
		})
	};

	const handleInput = (e) => {
		const target = e.target;
		const fields = state.fields;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const handleSelect = (selected) => {
		const fields = state.fields;
		fields.link = selected;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const validateForm = () => {
		let errors = {};
		const fields = state.fields;
		let formIsValid = true;
		if (!fields.title) {
			formIsValid = false;
			errors['title'] = 'عنوان محتوا را وارد کنید';
		}
		if (!fields.link_id) {
			formIsValid = false;
			errors['link_id'] = 'محتوای لینک را وارد کنید';
		}
		if (!fields.link) {
			formIsValid = false;
			errors['link_id'] = 'یک لینک انتخاب کنید';
		}

		setState((prev) => ({
			...prev,
			errors
		}));
		return formIsValid;
	};

	const submitForm = () => {
		if (validateForm()) {
			const data = {
				story_id: storyId,
				content_type: 'link',
				title: state.fields.title,
				desciption: state.fields.desciption,
				link: {
					url: state.fields.link_id,
					type: state.fields.link.value
				}
			};
			console.log('data: ', data);
			setState((prev) => ({
				...prev,
				isSubmiting: true
			}));
			axios.post(api.storeStory, data).then((res) => {
				const data = res.data;
				if (data.success) {
					setState((prev) => ({
						...prev,
						disabled: false
					}));
					toastify(<p>ثبت با موفقیت انجام شد</p>, 'success');
				}
			});
		}
	};

	const onSubmit = (e) => {
		e.preventDefault();
		submitForm();
	};

	return (
		<AddStoryBox
			type="link"
			icon={FileText}
			index={props.index}
			disabledSubmit={state.isSubmiting}
			onAdd={onAdd}
			onSubmit={onSubmit}
			onRemove={onRemove}>
			<div className="row">
				<div className="col-sm-6 mb-xxs-15">
					<div className={styles.field}>
						<label
							htmlFor={`title_${props.index}`}
							className={styles.label}>
							عنوان
						</label>
						<input
							type="text"
							id={`title_${props.index}`}
							name="title"
							className={styles.input}
							onChange={handleInput}
						/>
						{state.errors.title && (
							<FieldMessage text={state.errors.title} />
						)}
					</div>
				</div>
				<div className="col-sm-6 mb-xxs-15">
					<div className={styles.field}>
						<label htmlFor="link" className={styles.label}>
							لینک
						</label>
						<div className={styles.fieldGroup}>
							<Select
								isRtl
								placeholder=""
								closeMenuOnScroll
								isSearchable={false}
								styles={customSelect}
								className={styles.selectSocial}
								value={state.fields.link}
								options={state.social_list}
								onChange={handleSelect}
							/>
							<input
								type="text"
								id="link_id"
								name="link_id"
								className={clx(styles.input, styles.input_ltr)}
								defaultValue={state.fields.link_id}
								onChange={handleInput}
							/>
						</div>
						{state.errors.link_id && (
							<FieldMessage text={state.errors.link_id} />
						)}
					</div>
				</div>
				<div className="col-sm-12 mt-10">
					<div className={styles.field}>
						<label
							htmlFor={`desciption_${props.index}`}
							className={styles.label}>
							توضیحات
						</label>
						<textarea
							name="descrption"
							id={`descrption_${props.index}`}
							className={clx(styles.input, styles.textarea)}
							cols="10"
							rows="5"
							onChange={handleInput}
						/>
						{state.errors.descrption && (
							<FieldMessage text={state.errors.descrption} />
						)}
					</div>
				</div>
			</div>
		</AddStoryBox>
	);
};
